"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UPDATED_TERMINAL_SUBSCRIPTION_QUERY = exports.UPDATED_PAYMENT_OPTION_SUBSCRIPTION_QUERY = exports.UPDATED_PAYMENT_CONFIG_SUBSCRIPTION_QUERY = exports.UPDATED_PAYMENT_V2_SUBSCRIPTION_QUERY = exports.UPDATED_PAYMENT_SUBSCRIPTION_QUERY = void 0;
const constants_1 = require("../constants");
const enums_1 = require("../enums");
exports.UPDATED_PAYMENT_SUBSCRIPTION_QUERY = `subscription UpdatedPayment($merchantId: String!, $terminalId: String) {
  ${constants_1.APPSYNC_PAYMENT_NAMESPACE}(type: "${enums_1.EventRequestType.PAYMENT_EVENTS}", merchantId: $merchantId, terminalId: $terminalId) {
    data {
      id
      type
      attributes {
        merchantId
        provider
        sessionId
        orderId
        terminalId
        externalId
        externalUrl
        employeeId
        currency
        requestedAmount
        chargedAmount
        tipAmount
        feeAmount
        convenienceFeeAmount
        platformFeeAmount
        surchargeFeeAmount
        failReason
        cancelReason
        paymentFlowType
        paymentMethodType
        deferCapture
        lastUpdatedBy
        status
        refundType
        createdAt
        updatedAt
        authorizedAt
        capturedAt
        canceledAt
        refundedAt
        extraContent
        referenceId
      }
      relationships {
        customer {
          data {
            id
            type
          }
        }
        paymentOption {
          data {
            id
            type
          }
        }
      }
    }
    included {
      id
      type
      attributes
    }
  }
}`;
exports.UPDATED_PAYMENT_V2_SUBSCRIPTION_QUERY = `subscription updatedPaymentV2($merchantId: String!, $terminalId: String, $id: ID) {
  ${constants_1.APPSYNC_PAYMENT_V2_NAMESPACE}(type: "${enums_1.EventRequestType.V2_PAYMENT_EVENTS}", merchantId: $merchantId, terminalId: $terminalId, id: $id) {
    data {
      id
      type
      attributes {
        merchantId
        provider
        order {
          id
          totalPaidAmount
          totalRefundedAmount
        }
        resource {
          type
          resourceType
          paymentMethodType
          currency
          requestedAmount
          chargedAmount
          status
          statusReason
          originalPaymentId
          deferCapture
          employeeId
          terminalId
          tipAmount
          fees {
            type
            amount
          }
          providerInfo {
            extraContent
            referenceId
            externalId
            externalUrl
          }
          auditable {
            lastUpdatedBy
            createdAt
            updatedAt
            authorizedAt
            capturedAt
            failedAt
            canceledAt
            refundedAt
          }
        }
      }
    }
  }
}`;
exports.UPDATED_PAYMENT_CONFIG_SUBSCRIPTION_QUERY = `
subscription UpdatedPaymentConfiguration($merchantId: String!) {
  ${constants_1.APPSYNC_PAYMENT_CONFIG_NAMESPACE}(type: "${enums_1.EventRequestType.PAYMENT_CONFIG_EVENTS}", merchantId: $merchantId) {
    included {
      id
      type
      attributes
    }
    data {
      id
      type
      attributes {
          merchantName
          merchantId
          provider
          clientId
          clientSecret
          extraClientId
          extraClientSecret
          publicKey
          posDisplayName
          ecomDisplayName
          posEnabled
          ecomEnabled
          deferCapture
          createdAt
          updatedAt
          lastUpdatedBy
          webhookUrl
          extraContent
          status
          approvedAt
          deniedAt
      }
      relationships {
        fees {
          data {
            id
            type
          }
        }
      }
    }
  }
}
`;
exports.UPDATED_PAYMENT_OPTION_SUBSCRIPTION_QUERY = `
subscription UpdatedPaymentOption {
  ${constants_1.APPSYNC_PAYMENT_OPTION_NAMESPACE}(type: "${enums_1.EventRequestType.PAYMENT_OPTION_EVENTS}") {
    meta {
      requiredFields
    }
    data {
      id
      type
      attributes {
        provider
        posDisplayName
        ecomDisplayName
        description
        about
        imageUrl
        iconUrl
        minimumChargeAmount
        maximumChargeAmount
        increment
        integrated
        requireApproval
        posAvailable
        ecomAvailable
        availableCountries
        createdAt
        updatedAt
      }
    }
  }
}
`;
exports.UPDATED_TERMINAL_SUBSCRIPTION_QUERY = `
subscription UpdatedTerminal($merchantId: String!, $terminalId: String!) {
  ${constants_1.APPSYNC_PAYMENT_TERMINAL_NAMESPACE}(type: "${enums_1.EventRequestType.PAYMENT_TERMINAL_EVENTS}", merchantId: $merchantId, terminalId: $terminalId) {
    data {
      id
      type
      attributes {
        merchantId
        provider
        terminalId
        externalTerminalId
        externalPosId
        isDeleted
        createdAt
        updatedAt
        deletedAt
        lastUpdatedBy
      }
    }
  }
}
`;
//# sourceMappingURL=queries.js.map